import printDimensions from "../constants/printing/printDimensions";
import printOrientation from "../constants/printing/printOrientation";

const defaultMargin = 28; // 28 pixels = 1cm x 72 dots per inch

export default {
  paperSize: printDimensions.paperSize.A4,
  leftMargin: defaultMargin,
  orientation: printOrientation.Portrait,
  bottomMargin: defaultMargin,
  rightMargin: defaultMargin,
  paperWidth: 595,
  topMargin: defaultMargin,
  paperHeight: 842,
  scale: 0.75
};
